const generateNumber = () => Math.max(16, Math.round(Math.random() * 255));

export const generateHex = () =>
  `#${[generateNumber(), generateNumber(), generateNumber()]
    .map((item) => item.toString(16))
    .join('')}`;
